import React from 'react';
import UserAvatar from '../common/UserAvatar';

const tableConfig = (props) => ({
    columns: [
        { 
            title: 'userId', field: 'userId', filterAndSearch: true,
            render: rowData => <UserAvatar name={rowData.firstName} image={rowData.image}/>
        },
        { title: 'jobTitleName', field: 'jobTitleName', filterAndSearch: true },
        { title: 'employeeCode', field: 'employeeCode', filterAndSearch: true },
        { title: 'phoneNumber', field: 'phoneNumber', filterAndSearch: true }
    ],
})

export const data = [
    {
        "userId": "rirani",
        "jobTitleName": "Developer",
        "firstName": "Romin",
        "lastName": "Irani",
        "preferredFullName": "Romin Irani",
        "employeeCode": "E1",
        "region": "CA",
        "phoneNumber": "408-1234567",
        "emailAddress": "romin.k.irani@gmail.com"
    },
    {
        "userId": "nirani",
        "jobTitleName": "Developer",
        "firstName": "Neil",
        "lastName": "Irani",
        "preferredFullName": "Neil Irani",
        "employeeCode": "E2",
        "region": "CA",
        "phoneNumber": "408-1111111",
        "emailAddress": "neilrirani@gmail.com"
    },
    {
        "userId": "thanks",
        "jobTitleName": "Program Directory",
        "firstName": "Tom",
        "lastName": "Hanks",
        "preferredFullName": "Tom Hanks",
        "employeeCode": "E3",
        "region": "CA",
        "phoneNumber": "408-2222222",
        "emailAddress": "tomhanks@gmail.com"
    },
    {
        "userId": "thankss",
        "jobTitleName": "Program Directorys",
        "firstName": "Toms",
        "lastName": "Hankss",
        "preferredFullName": "Tom Hanksss",
        "employeeCode": "E3s",
        "region": "CAs",
        "phoneNumber": "408-22222222",
        "emailAddress": "tomhanks@gmail.coms"
    }
];

export default tableConfig;